<div style=" display: inline;block-size: 10%;">

  <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder " style="padding-right: 0px;padding-top: 10px;
  ">
    <div class="col-md-6" style="display: inline-block;padding-left: 0px;">
      <h2> Material Usage Trend</h2>
    </div>
    <div class="col-md-6" style="display: inline-block; position: relative;top: 7px;padding-right: 0px; ">
      <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px; float: right;" (click)="backBtn()">
        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
      </span>
      <span (click)="exportToExcel()" class="btn btn-yellow fntSz"
        style="cursor:pointer;margin-left: 10px;line-height: 23px; float: right;padding: 5px 11px;"
        title="Export to Excel">
        <span><i aria-hidden="true" class="fa fa-file-excel-o"></i></span>
      </span>
    </div>
  </div>

</div>

<div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder " style="padding-bottom: 0px;padding-top: 3px;padding-left: 0px;">

  <div class="col-md-4 col-4 col-sm-4 pad0 bgWhite color " style=" display:inline-flex ;padding-right: 10px;
      padding-top: 10px;">
    <span class="label orangeBadge fntSz {{filter == 0 ? 'activeOrange' : ''}}" (click)="typeFilter(0)"
      style="cursor:pointer;margin-left:0px;"><span>Day-wise</span></span>
    <span class="label yellowBadge fntSz {{filter == 1 ? 'activeYellow' : ''}}" (click)="typeFilter(1)"
      style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
          aria-hidden="true"></i></span> <span>Month-Wise</span></span>
    <span class="label greenBadge fntSz {{filter == 2 ? 'activeGreen' : ''}}" (click)="typeFilter(2)"
      style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
          aria-hidden="true"></i></span> <span>Year-Wise</span></span>
    <!-- <span class="label blueBadge fntSz {{filter == 3 ? 'activeBlue' : ''}}" (click)="typeFilter(3)"
          style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
              aria-hidden="true"></i></span> <span>Cancelled</span></span> -->
  </div>

  <div class="col-md-4 col-sm-4 col-xs-4 pad0" style="display:inline-flex">
    <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 60%;"
      placeholder="Select Category">
      <option value="0" disabled="" selected="" hidden="">Select Category</option>
      <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
      <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
      <option id="select" value="4" class="ng-binding ng-scope">Food</option>
      <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
    </select>
  </div>

  <div class="col-md-4 col-sm-4 col-xs-4 pad0" style="display:inline-flex">
    <!-- <span style="padding: 4px;">Item :</span> -->
    <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 60%;"
      placeholder="Select Category">
      <option value="0" disabled="" selected="" hidden="">Select Item</option>
      <!-- <option id="select" ng-repeat="x in categories" value="1">New</option> -->
      <option id="select" value="2" class="ng-binding ng-scope">Leptop</option>
      <option id="select" value="3" class="ng-binding ng-scope">Mobile</option>
      <option id="select" value="4" class="ng-binding ng-scope">Tv</option>
      <option id="select" value="5" class="ng-binding ng-scope">abc</option>
    </select>
  </div>

  <!-- <div class="col-md-6 col-sm-6 col-xs-6 pad0" style="display:inline-flex">
        <span style="padding: 4px;">View :</span>
        <div style="padding: 5px;">
          <input style="padding: 4px;" type="radio" id="view1" name="view" value="1" checked="checked" tabindex="5">
          <label for="view1"><span style="cursor:pointer;padding:4px;margin-right: 10px;">Day-wise</span></label>
          <input style="padding: 4px;" type="radio" id="view2" name="view" value="1">
          <label for="view2"><span style="cursor:pointer;padding:4px;margin-right: 10px;">Month-Wise</span></label>
          <input style="padding: 4px;" type="radio" id="view3" name="view" value="1">
          <label for="view3"><span style="cursor:pointer;padding:4px">Year-Wise</span></label>
        </div>
      </div> -->

  <!-- <div class="col-md-6 col-6 col-sm-6 pad0 bgWhite color " style="padding-right: 10px;
      padding-top: 10px;">
        <span class="label orangeBadge fntSz {{filter == 0 ? 'activeOrange' : ''}}" (click)="typeFilter(0)"
          style="cursor:pointer;margin-left:0px;"><span>Day-wise</span></span>
        <span class="label yellowBadge fntSz {{filter == 1 ? 'activeYellow' : ''}}" (click)="typeFilter(1)"
          style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
              aria-hidden="true"></i></span> <span>Month-Wise</span></span>
        <span class="label greenBadge fntSz {{filter == 2 ? 'activeGreen' : ''}}" (click)="typeFilter(2)"
          style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
              aria-hidden="true"></i></span> <span>Year-Wise</span></span>
        <!-- <span class="label blueBadge fntSz {{filter == 3 ? 'activeBlue' : ''}}" (click)="typeFilter(3)"
          style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
              aria-hidden="true"></i></span> <span>Cancelled</span></span> -->
  <!-- </div> -->

</div>



<div class="col-md-12 col-12 col-sm-12 pad0" style="padding-right: 0px; padding-top: 40px;">
  <table mat-table [dataSource]="dataSource" style="width: 100%;padding-top: 40px;">
    <!-- Item Column -->
    <ng-container matColumnDef="Item">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef> Item </th>
      <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.Item}} </td>
    </ng-container>

    <!-- Category Column -->
    <ng-container matColumnDef="Category">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef> Category </th>
      <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.Category}} </td>
    </ng-container>

    <!-- Unit Column -->
    <ng-container matColumnDef="Unit">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef> Unit </th>
      <td mat-cell *matCellDef="let element"> {{element.Unit}} </td>
    </ng-container>

    <!-- Monday Column -->
    <ng-container matColumnDef="Monday">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Monday </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Monday}} </td>
    </ng-container>

    <!-- Tuesday Column -->
    <ng-container matColumnDef="Tuesday">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Tuesday </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Tuesday}} </td>
    </ng-container>

    <!-- Wednesday Column -->
    <ng-container matColumnDef="Wednesday">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Wednesday </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Wednesday}} </td>
    </ng-container>
    <!-- Thursdat Column -->
    <ng-container matColumnDef="Thursdat">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Thursdat </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Thursdat}} </td>
    </ng-container>
    <!-- Friday Column -->
    <ng-container matColumnDef="Friday">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Friday </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Friday}} </td>
    </ng-container>
    <!-- Saturday Column -->
    <ng-container matColumnDef="Saturday">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Saturday </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Saturday}} </td>
    </ng-container>
    <!-- Sunday Column -->
    <ng-container matColumnDef="Sunday">
      <th class="header header-Table txtRight" mat-header-cell *matHeaderCellDef> Sunday </th>
      <td mat-cell *matCellDef="let element" class="txtRight"> {{element.Sunday}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator  [pageSizeOptions]="[5,10, 20]" style="margin-top: 15px;">
  </mat-paginator>
</div>